import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import HomePage from "@/pages/HomePage";

function App() {
  return (
    <div className="App min-h-screen bg-[color:var(--ga-bg)] text-[color:var(--ga-ink)]">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Toaster position="bottom-left" theme="light" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
